export default __webpack_public_path__ + "static/media/user.e4336a65.png";